import React, { useContext, useEffect, useState } from 'react';
import { CircularProgress, Typography, Box, Card, CardContent } from '@mui/material';
import UpdateSabitleAPI from '../../../apis/UpdateSabitleAPI';
import WebSabitler from '../../../apis/WebSabitler';
import { ThemeContext } from '../../../context/themeProviderContext';
import ResponsiveTabs from '../../../components/OB/Tabbar';
import GenelSabitleri from './WebSabitlerGuncelleTabs/GenelSabitleri';
import UyelikSabitleri from './WebSabitlerGuncelleTabs/UyelikSabitleri';
import TahsilatSabitleri from './WebSabitlerGuncelleTabs/TahsilatSabitleri';
import AbonelikSabitleri from './WebSabitlerGuncelleTabs/AbonelikSabitleri';
import SampasAyarlari from './WebSabitlerGuncelleTabs/SampasAyarlari';
import SessionStorageService from '../../../services/StorageService';
import DinamikFormYonetim from './DinamikFormYonetim';

const WebSabitlerGuncelle: React.FC = () => {
    const [isLoad, setIsLoad] = useState(true);
    const [message, setMessage] = useState<string>('');
    const [sabit, setSabit] = useState<any>(null);
    const [tabValue, setTabValue] = useState(0);
    const themeContext = useContext(ThemeContext);
    const user = SessionStorageService.getUserInfo();
    const isSuperAdmin = user?.isSuperAdmin === true;

    const handleTabChange = (event: any, newValue: number) => {
        setTabValue(newValue);
        setMessage('');
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoad(true);
            try {
                const response = await WebSabitler.getWebSabitler();
                if (response) {
                    setSabit({
                        ...response.data,
                        belediyeMail: response.data?.belediyeMail ?? '',
                        belediyeAdres: response.data?.belediyeAdres ?? '',
                        belediyeTelefon: response.data?.belediyeTelefon ?? '',
                        sicilTelKontrol: response.data?.sicilTelKontrol ?? '',
                        loginTelKontrol: response.data?.loginTelKontrol ?? '',
                        tahsilatAp: response.data?.tahsilatAp ?? '',
                        ilMi: response.data?.ilMi ?? '',
                    });
                } else {
                    setMessage('Beklenen formatta veri gelmedi.');
                }
            } catch (err) {
                console.error(err);
                setMessage('sabitler alınırken hata oluştu.');
            } finally {
                setIsLoad(false);
            }
        };

        fetchData();
    }, []);

    const handleUpdateAPI = async (updatedValues: any) => {
        try {
            await UpdateSabitleAPI.postUpdateSabitler(
                1,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                updatedValues.kvkMetni,
                updatedValues.sicilOlusturma,
                null,
                updatedValues.guvenlikMetni,
                updatedValues.belediyeAdres,
                updatedValues.belediyeMail,
                updatedValues.belediyeTelefon,
                updatedValues.sicilTelKontrol,
                updatedValues.loginTelKontrol,
                updatedValues.tahsilatAp,
                updatedValues.ilMi,
                updatedValues.yeniAbonlkMesafeliSozlesmeBase64 ?? null,
                updatedValues.devirBsvruMesafeliSozlesmeBase64 ?? null
            );
            setMessage('Güncelleme başarılı.');
            setSabit(updatedValues);
            // Theme context'i yenile
            if (themeContext?.reloadTheme) {
                themeContext.reloadTheme();
            }
        } catch (err) {
            console.error(err);
            setMessage('Güncelleme sırasında hata oluştu.');
        }
    };
    

    if (isLoad) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <div className="container py-4">
            <Typography variant="h5" gutterBottom>
                Web Sabitleri Güncelle
            </Typography>

            <Card sx={{ backgroundColor: '#fff', borderRadius: 2, boxShadow: 4 }}>
                <CardContent>
                    <ResponsiveTabs
                        items={[
                            { title: 'Genel Sabitler' },
                            { title: 'Üyelik Sabitleri' },
                            { title: 'Tahsilat Sabitleri' },
                            { title: 'Abonelik Sabitleri' },
                            { title: 'Başvuru Sabitleri' },
                            ...(isSuperAdmin ? [{ title: 'SAMPAS Ayarları' }] : []),
                        ]}
                        value={tabValue}
                        onChange={handleTabChange}
                        spreadWidth={true}
                    />

                    <Box sx={{ p: { xs: 1, sm: 2 }, mt: 2 }}>
                        {tabValue === 0 && <GenelSabitleri sabit={sabit} onUpdate={handleUpdateAPI} />}
                        {tabValue === 1 && <UyelikSabitleri sabit={sabit} onUpdate={handleUpdateAPI} />}
                        {tabValue === 2 && <TahsilatSabitleri sabit={sabit} onUpdate={handleUpdateAPI} />}
                        {tabValue === 3 && <AbonelikSabitleri sabit={sabit} onUpdate={handleUpdateAPI} />}
                        {tabValue === 4 && <DinamikFormYonetim />}
                        {tabValue === 5 && isSuperAdmin && <SampasAyarlari sabit={sabit} onUpdate={handleUpdateAPI} />}
                    </Box>

                    {message && (
                        <Typography
                            color={message.includes('başarılı') ? 'success.main' : 'error.main'}
                            align="center"
                            mt={2}
                        >
                            {message}
                        </Typography>
                    )}
                </CardContent>
            </Card>
        </div>
        
    );
};

export default WebSabitlerGuncelle;